/**
 * Product Type Configuration
 * 
 * Define what sections to show for each product type.
 */

export interface ProductSections {
  atGlance: SectionConfig;
  barrier: SectionConfig;
  underlyings: SectionConfig;
  coupons: SectionConfig;
  earlyRedemption: SectionConfig;
  performance: SectionConfig;
  couponDetails: SectionConfig;
}

export interface ProductTypeConfig {
  code: string;
  callableType?: string;
  name: string;
  sections: ProductSections;
}
export interface SectionConfig {
  enabled: boolean;
  props: Record<string, boolean>;
  title?: string; // Título opcional para la sección
}

export const DEFAULT_SECTIONS: ProductSections = {
  atGlance: {
    enabled: true,
    props: {
      couponBarrier: false,
      couponMemory: false,
      coupon: true,
      upside: false,
      upsideParticipation: false,
      downside: false,
      downsideParticipation: false,
      settlementType: false,
      grade: false,
      recovery: false,
      strikeLevel: false,
      bonusLevel: false,
      capLevel: false,
      maxReturn: false,
      // Warrant/Mini-futures specific fields
      premium: false,
      quotationType: false,
      strike: false,
      basketOptionType: false,
      upperStrike: false,
      lowerStrike: false,
      barrierType: false,
      lowerBarrier: false,
      upperBarrier: false,
      denomination: true,
      leverage: false,
      ratio: false,
      stopLoss: false,
      couponTrigger: false,
      couponFrequency: false,
      couponType: false,
      autocallTrigger: false,
      autocallFrequency: false,
      capitalProtectionPct: false,
      stepUp: false,
      couponMinimum: false,
      couponMaximum: false,
      issuePricePct: false,
      issuePrice: true,
      tradedNotional: true,
      currentNotional: true,
      maxYieldPct: false,
      maxYieldPaPct: false,
      discountPct: false,
      rebatePct: false,
      autocallType: false,
      participationDownPct: false,
    },
  },
  barrier: {
    enabled: true,
    props: {
      couponMemory: false,
      distanceCouponBarrier: false,
      stopLoss: false,
      distanceStopLoss: false,
      couponBarrier: false,
    },
  },
  underlyings: {
    enabled: true,
    props: {
      distanceCouponBarrier: false,
      barrierLevel: true,
      barrierDistance: true,
      upperStrike: false,
      strikeLevel: true,
      strikeDistance: true,
    },
  },
  coupons: {
    enabled: true,
    props: {},
  },
  earlyRedemption: {
    enabled: true,
    props: {},
  },
  performance: {
    enabled: true,
    props: {},
  },
  couponDetails: {
    enabled: false,
    props: {},
  },
};

